export default __webpack_public_path__ + "static/media/otherplayer3.15ebeabf.png";